export default "__VITE_ASSET__BIyiGWkf__"